export enum AnnouncementType {
	INFO = 'informational',
	NOTICE = 'notice',
	WARNING = 'warning'
}
